export const typography = {
  body: "Poppins, monospace",
  heading: "Poppins, monospace",
  primary: "Poppins",
};
